import { gql } from '@apollo/client';

const REPORT_QUERY = gql`
  query report($id: ID!) {
    report(id: $id) {
      id
      reportId
      type
      createdAt
      start
      stop
      status
      assignee {
        id
        firstName
        lastName
        roles
      }
      technicianComments
      lastModified
      isRenderingBackground
      study {
        id
        friendlyId
      }
      event {
        id
        friendlyId
      }
      inbox {
        date
        priority
      }
      isNewFormat
      formatVersion
      aiFormatVersion
      profile
    }
  }
`;

export default REPORT_QUERY;
